var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"overlay"},[_c('p',{class:[{description:true},_vm.classes],domProps:{"innerHTML":_vm._s(this.settings.text)},on:{"click":function($event){return _vm.clicked()}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }